<template>
<div>
  <el-form-item label="监测站点">
    <div style="height:32px"></div>
    <ul ref="site-selector" class="site-selector">
      <li
        v-for="site in profileSites"
        :key="site.id"
        :class="{
        selected: site.id === model.siteId
      }"
        @click="onSiteClick(site)"
      >{{site.name}}</li>
    </ul>
  </el-form-item>

  <el-form-item>
    <el-switch v-model="model.hideNotSelectedSite" active-text="隐藏未选择的站房" />
  </el-form-item>
</div>
</template>

<script>
import BaseHySplit from './BaseHySplit'

export default {
  name: 'SiteSelector',
  extends: BaseHySplit,
  props: {
    model: {
      required: true,
      type: Object
    }
  },
  methods: {
    setIdLngLat (site) {
      let {model} = this

      if (site.id !== model.siteId) {
        model.lon = site.longitude
        model.lat = site.latitude
        model.siteId = site.id
        return true
      }
      return false
    },
    setSite () {
      let sites = this.profileSites

      if (sites.length > 0 && this.setIdLngLat(sites[0])) {
        this.$emit('change')
      }
    },
    onSiteClick (site, isScrollIntoView) {
      if (this.setIdLngLat(site) && isScrollIntoView) {
        setTimeout(() => {
          let li = this.$refs['site-selector'].querySelector('.selected')
          li.scrollIntoView()
        }, 0)
      }
    }
  },
  watch: {
    profileSites () {
      this.setSite()
    }
  },
  created () {
    this.setSite()
  }
}
</script>

<style lang="scss" scoped>
.site-selector {
  height: 200px;
  margin: 0;
  padding: 5px 0;
  border: 1px solid #cccccc;
  list-style: none;
  overflow: auto;

  > li {
    padding: 0 12px;
    cursor: pointer;

    &:hover {
      background-color: #f5f7fa;
    }

    &.selected {
      color: #409eff;
      background-color: #ecf5ff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/04Statistical-Analysis/03Pollution/04HYSPLIT/SiteSelector.vue